import type { FC, ReactNode } from 'react';
import React from 'react';

import { VRM } from '@motorway/mw-highway-code/alpha';

import BasicThumbnail from 'Components/Thumbnail/BasicThumbnail';
import type { VehicleLeadImage } from 'Types/vehicleImage';
import { applyCypressData } from 'Utilities/helpers';

import styles from './VehicleData.module.scss';

export type VehicleDataProps = {
	badges?: ReactNode[];
	cypressId: string;
	leadPhoto?: VehicleLeadImage;
	make: string;
	model: string;
	prettyVrm: string;
	shouldDisplayPhoto?: boolean;
};

const VehicleData: FC<VehicleDataProps> = ({
	badges = [],
	cypressId,
	leadPhoto,
	make,
	model,
	prettyVrm,
	shouldDisplayPhoto = true,
}) => {
	const VrmBadge = <VRM key="vrmBadge" size="xsmall" text={prettyVrm} />;
	const badgeList = [VrmBadge, ...badges];

	return (
		<div className={styles.container} {...applyCypressData(cypressId)}>
			{shouldDisplayPhoto && (
				<div className={styles.imageContainer}>
					{leadPhoto?.url ? (
						<div>
							<BasicThumbnail
								authenticated
								alt={prettyVrm}
								className={styles.basicThumbnail}
								height={56}
								image={leadPhoto}
								imgAttributes={{}}
								rootComponent="VehicleData"
								width={75}
							/>
						</div>
					) : (
						<div>
							<div className={styles.placeholderMissingImage} />
						</div>
					)}
				</div>
			)}
			<div className={styles.textContainer}>
				<div className={styles.badges}>{badgeList?.map?.((BadgeItem, idx) => <span key={idx}>{BadgeItem}</span>)}</div>
				<span className={styles.vehicleText}>{`${make} ${model || ''}`.trim()}</span>
			</div>
		</div>
	);
};

export default VehicleData;
